import { FC } from 'react';
import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatientForSendai } from '../useIncidentDetailForSendai';

type Props = {
  bystander: IncidentDetailPatientForSendai['bystander'];
};

export const BystanderView: FC<Props> = ({ bystander }) => {
  if (!bystander) {
    return (
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="バイスタンダー" />
          <InfoDisplay title="バイスタンダー" content="" />
        </div>
      </BorderedContainer>
    );
  }

  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="バイスタンダー" />
        {/* 人工呼吸 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="人工呼吸"
            content={bystander.isVentilationPerformed}
          />
          <InfoDisplay
            title="人工呼吸開始日時"
            content={bystander.ventilationData?.startedAt ?? ''}
          />
        </div>
        {/* 胸骨圧迫 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="胸骨圧迫"
            content={bystander.isChestCompressionPerformed}
          />
          <InfoDisplay
            title="胸骨圧迫開始日時"
            content={bystander.chestCompressionData?.startedAt ?? ''}
          />
        </div>
        {/* 実施者情報 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="実施者区分" content={bystander.bystanderType} />
          <InfoDisplay
            title="実施者区分(その他)"
            content={bystander.bystanderTypeOther}
          />
          <InfoDisplay
            title="実施者資格"
            content={bystander.qualificationOther}
          />
        </div>
        {/* AED関連 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="現場AED有無" content={bystander.aed} />
          <InfoDisplay
            title="AEDパッド装着"
            content={bystander.isAedPadAttached}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="除細動適応" content={bystander.aedApplyType} />
          <InfoDisplay
            title="除細動 不明理由"
            content={bystander.aedAnalysisUnknownReason}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="除細動" content={bystander.aed} />
          <InfoDisplay
            title="除細動 初回時刻"
            content={bystander.aedInitiallyUsedAt}
          />
          <InfoDisplay title="除細動回数" content={bystander.aedCountType} />
        </div>
        {/* 市民応急処置 */}
        {bystander.treatments && bystander.treatments.length > 0 && (
          <div className="flex flex-col gap-[16px]">
            {bystander.treatments.map((item, index) => (
              <div
                key={`${item.treatment}-${index}`}
                className="flex flex-wrap gap-x-[40px] gap-y-[16px] xl:gap-x-[96px]"
              >
                <InfoDisplay
                  title={`市民応急処置(${index + 1}回目)`}
                  content={item.treatment}
                />
                <InfoDisplay
                  title={`応急処置者(${index + 1}回目)`}
                  content={item.treatmentPerson}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </BorderedContainer>
  );
};
